import Block from './Block'

export default class Brand extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    if (this.link_fr) this.link_fr.href = this.el.dataset.langFr
    if (this.link_en) this.link_en.href = this.el.dataset.langEn
    if (this.link_de) this.link_de.href = this.el.dataset.langDe
    if (this.link_it) this.link_it.href = this.el.dataset.langIt
    if (this.link_pl) this.link_pl.href = this.el.dataset.langPl
    if (this.link_es) this.link_es.href = this.el.dataset.langEs
  }

  getElems() {
    super.getElems()

    this.link_fr = document.querySelector('.wpml-ls-sub-menu .wpml-ls-item-fr a')
    this.link_en = document.querySelector('.wpml-ls-sub-menu .wpml-ls-item-en a')
    this.link_de = document.querySelector('.wpml-ls-sub-menu .wpml-ls-item-de a')
    this.link_it = document.querySelector('.wpml-ls-sub-menu .wpml-ls-item-it a')
    this.link_pl = document.querySelector('.wpml-ls-sub-menu .wpml-ls-item-pl a')
    this.link_es = document.querySelector('.wpml-ls-sub-menu .wpml-ls-item-es a')
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Brand.js